import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Show } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { MeProvider, useMe } from "@/context/MeContext";
import { Toaster } from "@/components/ui/sonner";
import AppShell from "@/components/AppShell";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import NewTrip from "@/pages/NewTrip";
import TripDetail from "@/pages/TripDetail";
import Users from "@/pages/Users";
import Profile from "@/pages/Profile";
import AircraftList from "@/pages/AircraftList";
import Operators from "@/pages/Operators";
import QuoteInbox from "@/pages/QuoteInbox";
import JetCardRequests from "@/pages/JetCardRequests";
import PendingAccess from "@/pages/PendingAccess";
import SharePage from "@/pages/SharePage";
import StopReminders from "@/pages/StopReminders";
import FlightTracking from "@/pages/FlightTracking";
import TrackingDetail from "@/pages/TrackingDetail";

const Loader = () => (
  <div className="min-h-screen grid place-items-center" data-testid="app-loader">
    <div className="jet-loader" />
  </div>
);

function Gate() {
  const { me, error } = useMe();
  if (error) return <div className="p-10 text-rose-300" data-testid="me-error">{error}</div>;
  if (!me) return <Loader />;
  if (me.role === "pending") return <PendingAccess />;
  return <Outlet />;
}

function Protected() {
  return (
    <>
      <Show when="signed-in">
        <MeProvider>
          <Gate />
        </MeProvider>
      </Show>
      <Show when="signed-out">
        <Navigate to="/sign-in" replace />
      </Show>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/sign-in/*" element={<AuthPage mode="in" />} />
            <Route path="/sign-up/*" element={<AuthPage mode="up" />} />
            <Route path="/p/:token" element={<SharePage />} />
            <Route path="/stop-reminders/:token" element={<StopReminders />} />
            <Route element={<Protected />}>
              <Route element={<AppShell />}>
                <Route index element={<Dashboard />} />
                <Route path="trips/new" element={<NewTrip />} />
                <Route path="trips/:id" element={<TripDetail />} />
                <Route path="tracking" element={<FlightTracking />} />
                <Route path="tracking/:id" element={<TrackingDetail />} />
                <Route path="users" element={<Users />} />
                <Route path="profile" element={<Profile />} />
                <Route path="aircraft" element={<AircraftList />} />
                <Route path="operators" element={<Operators />} />
                <Route path="quote-inbox" element={<QuoteInbox />} />
                <Route path="jet-cards" element={<JetCardRequests />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
